module.exports = __webpack_public_path__ + "static/media/7.a0969b14.jpg";